import Application from './Application.vue';

export default Application;
